import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBack: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="back"><path d="M16.4422 4.41841C17.9314 3.36641 20 4.4192 20 6.22912V17.7709C20 19.5808 17.9314 20.6336 16.4422 19.5816L8.27292 13.8108C7.01663 12.9233 7.01662 11.0768 8.27291 10.1893L16.4422 4.41841Z" fill="currentColor"/><path d="M4 4.82998C4 4.42033 4.33579 4.08824 4.75 4.08824C5.16421 4.08824 5.5 4.42033 5.5 4.82998V19.1701C5.5 19.5798 5.16421 19.9118 4.75 19.9118C4.33579 19.9118 4 19.5798 4 19.1701V4.82998Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBack;
